function clean(value) {
  return String(value || "").trim();
}

function addIds(target, values) {
  if (!Array.isArray(values)) return;
  values.forEach((value) => {
    const id = clean(value);
    if (id) target.add(id);
  });
}

function addRowIds(target, rows) {
  if (!Array.isArray(rows)) return;
  rows.forEach((row) => {
    const id = clean(row?.treeNodeId || row?.subjectTreeNodeId || row?.subjectNodeId);
    if (id) target.add(id);
  });
}

function rowIsIndividual(row) {
  const rawType = clean(
    row?.holderType || row?.shareholderEntityType || row?.type || row?.partyType
  ).toLowerCase();
  if (!rawType) return true;
  return (
    rawType === "individual" ||
    rawType === "person" ||
    rawType === "natural person" ||
    rawType === "private individual"
  );
}

export function getQualifiedUboNodeIds(ownership = {}) {
  const ids = new Set();
  const assessment = ownership?.uboAssessment || {};

  addIds(ids, assessment.thresholdUboIds);
  addIds(ids, assessment.qualifiedUboIds);
  addIds(ids, assessment.documentShareholderIds);
  addRowIds(ids, assessment.qualifiedUbos);
  addRowIds(ids, ownership?.qualifiedUbos);

  return ids;
}

export function isQualifiedUboRow(row, qualifiedNodeIds) {
  if (!row || !qualifiedNodeIds || !qualifiedNodeIds.size) return false;
  if (!rowIsIndividual(row)) return false;
  const rowIds = [
    row?.treeNodeId,
    row?.subjectTreeNodeId,
    row?.subjectNodeId,
    row?._treeNodeId,
  ].map(clean);
  return rowIds.some((id) => id && qualifiedNodeIds.has(id));
}
